// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"7cfb6d9a","657":"7cfb6d9a"}[chunkId] + ".chunk.css";
};